'use client';

import { c as _c } from "react/compiler-runtime";
import { FOCUS_RING } from '@common/components/interaction';
import SvgChevrondown from '@common/icon/SvgChevrondown';
import SvgChevronup from '@common/icon/SvgChevronup';
import { cn } from '@core/utils';
import { autoUpdate, flip, FloatingFocusManager, FloatingPortal, offset, shift, size, useClick, useDismiss, useFloating, useInteractions, useRole } from '@floating-ui/react';
import Image from 'next/image';
import { useRef, useState } from 'react';
import { RegionFinderContent } from '@/app/donation/_components/RegionFinderContent';
import { useRegionFinder } from '@/app/donation/_hooks/useRegionFinder';
export const RegionFinderDropdown = () => {
  const $ = _c(37);
  const [isOpen, setIsOpen] = useState(false);
  const searchInputRef = useRef(null);
  let t0;
  if ($[0] !== isOpen) {
    t0 = {
      enabled: isOpen
    };
    $[0] = isOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const finder = useRegionFinder(t0);
  let t1;
  if ($[2] !== finder) {
    t1 = opened => {
      setIsOpen(opened);
      if (!opened) {
        finder.reset();
      }
    };
    $[2] = finder;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleOpenChange = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [offset(8), flip(), shift({
      padding: 12
    }), size({
      padding: 12,
      apply(t3) {
        const {
          availableHeight,
          elements
        } = t3;
        elements.floating.style.maxHeight = `${Math.max(0, availableHeight)}px`;
      }
    })];
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== handleOpenChange || $[6] !== isOpen) {
    t3 = {
      open: isOpen,
      onOpenChange: handleOpenChange,
      placement: "bottom-start",
      whileElementsMounted: autoUpdate,
      middleware: t2
    };
    $[5] = handleOpenChange;
    $[6] = isOpen;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    refs,
    floatingStyles,
    context
  } = useFloating(t3);
  const t4 = useClick(context);
  const t5 = useDismiss(context);
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      role: "dialog"
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = useRole(context, t6);
  let t8;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t7) {
    t8 = [t4, t5, t7];
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const {
    getReferenceProps,
    getFloatingProps
  } = useInteractions(t8);
  let t9;
  if ($[13] !== refs) {
    t9 = element => refs.setReference(element);
    $[13] = refs;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = cn("flex h-46 items-center gap-4 rounded-small bg-Gray-50 p-12", "transition-colors duration-150 hover:bg-Gray-100 active:bg-Gray-200 motion-reduce:transition-none", FOCUS_RING);
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== getReferenceProps) {
    t11 = getReferenceProps();
    $[16] = getReferenceProps;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Image src="/assets/pngs/region-finder-pin.png" alt="" width={22} height={22} className="shrink-0" />;
    t13 = <span className="font-600 text-Gray-black typo-body4">지역찾기</span>;
    $[18] = t12;
    $[19] = t13;
  } else {
    t12 = $[18];
    t13 = $[19];
  }
  let t14;
  if ($[20] !== isOpen) {
    t14 = isOpen ? <SvgChevronup className="size-12 shrink-0 text-Gray-black" /> : <SvgChevrondown className="size-12 shrink-0 text-Gray-black" />;
    $[20] = isOpen;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t11 || $[23] !== t14 || $[24] !== t9) {
    t15 = <button ref={t9} type="button" className={t10} {...t11}>{t12}{t13}{t14}</button>;
    $[22] = t11;
    $[23] = t14;
    $[24] = t9;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== context || $[27] !== finder || $[28] !== floatingStyles || $[29] !== getFloatingProps || $[30] !== handleOpenChange || $[31] !== isOpen || $[32] !== refs) {
    t16 = isOpen && <FloatingPortal><FloatingFocusManager context={context} modal={false} initialFocus={searchInputRef}><div ref={element_0 => refs.setFloating(element_0)} style={floatingStyles} {...getFloatingProps()} aria-label={"\uC9C0\uC5ED\uCC3E\uAE30"} className="z-20 flex h-[33.75rem] w-[30rem] flex-col overflow-hidden rounded-medium bg-Gray-50 shadow-[0_0_14px_0_rgba(0,0,0,0.2)]"><RegionFinderContent dropdown={true} finder={finder} inputRef={searchInputRef} onSelect={id => {
            handleOpenChange(false);
            finder.handleSelectRegion(id);
          }} /></div></FloatingFocusManager></FloatingPortal>;
    $[26] = context;
    $[27] = finder;
    $[28] = floatingStyles;
    $[29] = getFloatingProps;
    $[30] = handleOpenChange;
    $[31] = isOpen;
    $[32] = refs;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t15 || $[35] !== t16) {
    t17 = <>{t15}{t16}</>;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
};